import IconAsMaskImage from "../IconAsMaskImage";

const Messenger = ({ pureSvg, className, color }) => {
  const svg = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2767 22.5237C14.8265 22.5325 17.3792 21.4621 19.1977 19.3047C21.9187 16.0769 22.0043 11.2332 19.3913 7.91759C15.9896 3.59985 9.70643 3.32957 5.94297 7.10575C3.19186 9.8652 2.59768 13.9536 4.13904 17.2976C4.26741 17.6186 4.76434 18.5007 5.0979 19.0812C5.28753 19.411 5.26808 19.8179 5.04927 20.1282C4.82949 20.4385 4.55137 20.8357 4.33451 21.1616C3.94649 21.7441 4.35882 22.5247 5.05705 22.5237L5.59644 22.5235C7.97013 22.5225 11.4492 22.521 12.2767 22.5237Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.86523 15.0977C9.42635 16.3778 10.711 17.2755 12.2037 17.2755C13.6955 17.2755 14.9801 16.3778 15.5412 15.0977"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
};

export default Messenger;
